module.exports = __webpack_public_path__ + "static/media/YF37_1.3e6e5b97.jpg";